// extracted by mini-css-extract-plugin
export default {"container":"companies_container__pRPBO"};